// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoBar_root__2W30p","text":"InfoBar_text__rO-RO"};